import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { BookingFlowStep, InfoButton, PootsyBox, PootsyButton } from "../DesignFunctions"
import * as actions from "../../actions/acBookingFlow"
import { BookingFlowStep as Step } from "../../actions/acBookingFlow"
import pinNeeds from '../../static/img/pin-needs.png'
import timer from '../../static/img/timer-black.png'
import PootsyStepper from "../shared/PootsyStepper"
import BookingService from "./BookingService"
import { CabinetsIcon, FridgeIcon, IronIcon, LaundryIcon, OvenIcon, WindowsIcon } from '../../static/svg/booking-service-icons'
import PootsySelectInput from "../shared/PootsySelectInput"
import { PootsyTextInput } from "../InputsFunctions"

class BookingFlowNeeds extends Component {

	constructor(props) {
		super(props)

		this.state = {
			isOptionsVisible: false
		}
	}

	componentWillMount = () => {
		if (this.props.meta.options.affiliateID !== undefined) {
			this.props.dispatch(actions.loadPrefilledAffiliate())
		}
		else if (this.props.userAffiliates.length > 0) {
			this.setState({ isOptionsVisible: true })
			this.props.dispatch(actions.bookingFlowDataChange({ selectedAffiliate: this.props.userAffiliates[0] }))
		}
	}

	componentWillReceiveProps = newProps => {
		if (newProps.data.selectedAffiliate !== undefined && this.props.data.selectedAffiliate !== newProps.data.selectedAffiliate) {
			this.setState({ isOptionsVisible: true })
		}
	}

	render() {
		let { t } = this.context

		let headerContent = {
			picto: pinNeeds,
			title: t('booking_flow_second_step_header'),
			subtitle: t('booking_flow_second_step_input_prompt')
		}

		return (
			<BookingFlowStep customClass="step-two" headerContent={headerContent}>
				<div className="columns-container">
					<div className="first-column">

						<PootsyBox label={t('booking_flow_bedrooms')} rightComponent={this.renderBedroomsStepper()}/>
						<PootsyBox label={t('booking_flow_bathrooms')} rightComponent={this.renderBathroomsStepper()}/>
						<PootsyBox label={t('booking_flow_frequency')} rightComponent={this.renderFrequencySelect()}/>

						<div className="options-switch" onClick={this.onOptionsSwitchClick}>
							<div className={"arrow" + (this.state.isOptionsVisible ? " opened" : "")}/>
							<div className="label">{t('booking_flow_additional_options')}</div>
							<div className="divider"/>
						</div>

					</div>
					{this.renderBookingServices()}
				</div>

				<div className={"options" + (this.state.isOptionsVisible ? "" : " gone")}>
					<div className="first-column">
						{this.renderLanguagesSelect()}
						{this.renderAffiliatesSelect()}
					</div>
					<div className="second-column">
						{this.renderWorkerSodexoNumberInput()}
						{this.renderWorkersSelect()}
					</div>
				</div>

				<div className="estimation">
					<img src={timer} alt="timer"/>
					<div className="text">
						<div
							className="title">{t('booking_flow_needs_estimation_title') + " " + this.props.duration + " " + t('common_hours')}</div>
						<div className="description">{t('booking_flow_needs_estimation_description')}</div>
					</div>
				</div>

				<div className="divider"/>

				<div className="bottom">
					<div className="previous-step" onClick={this.goToPreviousStep}>← {t('previous')}</div>
					<PootsyButton text={t('next_step')} onClick={this.onNextButtonClick}/>
				</div>

			</BookingFlowStep>
		)
	}

	renderBedroomsStepper = () => {
		return (<PootsyStepper
			minValue={0}
			maxValue={5}
			initialValue={this.props.bookingFlow.bedroomsCount}
			onValueChanged={this.onBedroomsValueChanged}/>)
	}

	renderBathroomsStepper = () => {
		return (<PootsyStepper
			minValue={0}
			maxValue={5}
			initialValue={this.props.bookingFlow.bathroomsCount}
			onValueChanged={this.onBathroomsValueChanged}/>)
	}

	renderFrequencySelect = () => {
		let { t } = this.context

		let options = [
			{
				value: 0,
				label: t('booking_flow_frequency_once')
			},
			{
				value: 1,
				label: t('booking_flow_frequency_every_week')
			},
			{
				value: 2,
				label: t('booking_flow_frequency_every_two_weeks')
			}
		]

		return (
			<PootsySelectInput options={options}
							   selectedValue={this.props.data.frequency ? this.props.data.frequency : 0}
							   onChange={this.onFrequencyChanged}/>
		)
	}

	renderBookingServices = () => {
		let { t } = this.context

		let bookingServices = [
			{
				id: 'inside_fridge',
				title: t('booking_service_fridge'),
				icon: <FridgeIcon isSelected={this.isBookingServiceSelected('inside_fridge')}/>,
				isSelected: this.isBookingServiceSelected('inside_fridge')
			},
			{
				id: 'inside_cabinets',
				title: t('booking_service_cabinets'),
				icon: <CabinetsIcon isSelected={this.isBookingServiceSelected('inside_cabinets')}/>,
				isSelected: this.isBookingServiceSelected('inside_cabinets')
			},
			{
				id: 'inside_oven',
				title: t('booking_service_oven'),
				icon: <OvenIcon isSelected={this.isBookingServiceSelected('inside_oven')}/>,
				isSelected: this.isBookingServiceSelected('inside_oven')
			},
			{
				id: 'clean_windows',
				title: t('booking_service_windows'),
				icon: <WindowsIcon isSelected={this.isBookingServiceSelected('clean_windows')}/>,
				isSelected: this.isBookingServiceSelected('clean_windows')
			},
			{
				id: 'laundry',
				title: t('booking_service_laundry'),
				icon: <LaundryIcon isSelected={this.isBookingServiceSelected('laundry')}/>,
				isSelected: this.isBookingServiceSelected('laundry')
			},
			{
				id: 'ironing',
				title: t('booking_service_ironing'),
				icon: <IronIcon isSelected={this.isBookingServiceSelected('ironing')}/>,
				isSelected: this.isBookingServiceSelected('ironing')
			},
		]

		return (
			<div className="second-column">
				<div className="title">{t('booking_flow_desired_booking_services')}</div>
				<div className="services-line">
					<BookingService bookingService={bookingServices[0]}
									onClick={this.onBookingServiceClick}/>
					<BookingService bookingService={bookingServices[1]}
									onClick={this.onBookingServiceClick}/>
					<BookingService bookingService={bookingServices[2]}
									onClick={this.onBookingServiceClick}/>
				</div>
				<div className="services-line">
					<BookingService bookingService={bookingServices[3]}
									onClick={this.onBookingServiceClick}/>
					<BookingService bookingService={bookingServices[4]}
									onClick={this.onBookingServiceClick}/>
					<BookingService bookingService={bookingServices[5]}
									onClick={this.onBookingServiceClick}/>
				</div>
			</div>
		)
	}

	renderLanguagesSelect = () => {
		let { t } = this.context

		if (this.props.data.workerLanguages) {
			let options = []
			options.push({
				value: '',
				label: t('booking_flow_worker_language_undefined'),
				object: undefined
			})
			this.props.data.workerLanguages.forEach((workerLanguage) => {
				options.push({
					value: workerLanguage.id,
					label: workerLanguage.attributes.name,
					object: workerLanguage
				})
			})

			return (
				<PootsySelectInput label={t('booking_flow_choose_worker_language')}
								   options={options}
								   selectedValue={this.props.data.selectedWorkerLanguage ? this.props.data.selectedWorkerLanguage.id : ''}
								   onChange={this.onWorkerLanguageSelected}/>
			)
		}

		return null
	}

	renderAffiliatesSelect = () => {
		let { data: { affiliates, selectedAffiliate }, meta: { allowAffiliateChange } } = this.props
		let { t } = this.context

		if (affiliates) {
			let options = []
			options.push({
				value: '',
				label: t('booking_flow_affiliate_undefined'),
				object: undefined
			})
			affiliates.forEach((affiliate) => {
				options.push({
					value: affiliate.id,
					label: affiliate.attributes.commercial_name,
					object: affiliate
				})
			})

			return (
				<PootsySelectInput label={t('booking_flow_choose_affiliate')}
								   options={options}
								   infoText={t('booking_flow_choose_affiliate_info')}
								   selectedValue={selectedAffiliate ? selectedAffiliate.id : ''}
								   onChange={this.onAffiliateSelected}
								   disableSelection={!allowAffiliateChange}/>
			)
		}
	}

	renderWorkersSelect = () => {
		let { t } = this.context

		if (this.props.data.workers) {
			let options = []
			options.push({
				value: '',
				label: t('booking_flow_worker_undefined'),
				object: undefined
			})
			this.props.data.workers.forEach((worker) => {
				options.push({
					value: worker.id,
					label: worker.attributes.display_name,
					object: worker
				})
			})

			return (
				<PootsySelectInput label={t('booking_flow_choose_worker')}
								   options={options}
								   infoText={t('booking_flow_choose_worker_info')}
								   selectedValue={this.props.data.selectedWorker ? this.props.data.selectedWorker.id : ''}
								   onChange={this.onWorkerSelected}/>
			)
		}
	}

	renderWorkerSodexoNumberInput = () => {
		let { t } = this.context

		return (
			<div className="worker-sodexo-number">
				<div className="label">{t('booking_flow_i_know_a_worker')} <InfoButton text={t('booking_flow_i_know_a_worker_info')}/></div>
				<PootsyTextInput placeholder={t('booking_flow_worker_sodexo_number_placeholder')}
								 value={this.props.data.workerSodexoNumber ? this.props.data.workerSodexoNumber : ''}
								 onChange={this.onWorkerSodexoNumberChanged}/>
			</div>

		)
	}

	onBedroomsValueChanged = (bedroomsCount) => {
		this.props.dispatch(actions.bookingFlowDataChange({ bedroomsCount: bedroomsCount }))
		this.props.dispatch(actions.updateDuration())
	}

	onBathroomsValueChanged = (bathroomsCount) => {
		this.props.dispatch(actions.bookingFlowDataChange({ bathroomsCount: bathroomsCount }))
		this.props.dispatch(actions.updateDuration())
	}

	onFrequencyChanged = (option) => {
		this.props.dispatch(actions.bookingFlowDataChange({ frequency: option.value }))
	}

	onBookingServiceClick = (bookingService) => {
		this.props.dispatch(actions.bookingFlowToggleBookingService(bookingService.id))
		this.props.dispatch(actions.updateDuration())
	}

	isBookingServiceSelected = (bookingServiceId) => {
		return this.props.data.bookingServices.includes(bookingServiceId)
	}

	onOptionsSwitchClick = () => {
		this.setState({ isOptionsVisible: !this.state.isOptionsVisible })
	}

	onWorkerLanguageSelected = (workerLanguageOption) => {
		this.props.dispatch(actions.bookingFlowDataChange({ selectedWorkerLanguage: workerLanguageOption.object }))
	}

	onAffiliateSelected = (affiliateOption) => {
		this.props.dispatch(actions.bookingFlowDataChange({ selectedAffiliate: affiliateOption.object }))
	}

	onWorkerSelected = (workerOption) => {
		this.props.dispatch(actions.bookingFlowDataChange({ selectedWorker: workerOption.object }))
	}

	onWorkerSodexoNumberChanged = (e) => {
		this.props.dispatch(actions.bookingFlowDataChange({ workerSodexoNumber: e.target.value }))
	}

	goToPreviousStep = () => {
		this.props.dispatch(actions.bookingFlowMetaChange({ currentStep: Step.WELCOME }))
	}

	onNextButtonClick = () => {
		this.props.dispatch(actions.bookingFlowValidateStepNeeds())
	}

}

BookingFlowNeeds.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	bookingFlow: state.dataReducer.bookingFlow,
	data: state.dataReducer.bookingFlow,
	meta: state.metadataReducer.bookingFlow,
	duration: state.dataReducer.bookingFlow.duration,
	userAffiliates: state.dataReducer.userAffiliates,
})
export default connect(mapStateToProps)(BookingFlowNeeds);


// WEBPACK FOOTER //
// ./src/components/bookingflow/BookingFlowNeeds.js